/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CvassistantCvAssistantProtocolsAuthorizeSellersRequest,
  CvassistantCvAssistantProtocolsAuthorizeSellersResponse,
  CvassistantCvAssistantProtocolsDismissSellersRequest,
  CvassistantCvAssistantProtocolsDismissSellersResponse,
  CvassistantCvAssistantProtocolsEngageSellersRequest,
  CvassistantCvAssistantProtocolsEngageSellersResponse,
  CvassistantCvAssistantProtocolsExcelExportBySellerIdRequest,
  CvassistantCvAssistantProtocolsExcelExportRequest,
  CvassistantCvAssistantProtocolsExcelExportResponse,
  CvassistantCvAssistantProtocolsFileInfoListResponse,
  CvassistantCvAssistantProtocolsGetChatAsExcelRequest,
  CvassistantCvAssistantProtocolsGetChatAsSnapshotRequest,
  CvassistantCvAssistantProtocolsGetDetectedListingDetailsRequest,
  CvassistantCvAssistantProtocolsGetDetectedListingDetailsResponse,
  CvassistantCvAssistantProtocolsGetFilterInfoResultRequest,
  CvassistantCvAssistantProtocolsGetFilterInfoResultResponse,
  CvassistantCvAssistantProtocolsGetSellerCountRequest,
  CvassistantCvAssistantProtocolsGetSellerCountResponse,
  CvassistantCvAssistantProtocolsGetSellerDetailsRequest,
  CvassistantCvAssistantProtocolsGetSellerDetailsResponse,
  CvassistantCvAssistantProtocolsGetSellerListRequest,
  CvassistantCvAssistantProtocolsGetSellerListResponse,
  MarqCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ConversationalAssistant<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name CountCreate
   * @request POST:/cv-assistant/count
   */
  countCreate = (data: CvassistantCvAssistantProtocolsGetSellerCountRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsGetSellerCountResponse, any>({
      path: `/cv-assistant/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ListCreate
   * @request POST:/cv-assistant/list
   */
  listCreate = (data: CvassistantCvAssistantProtocolsGetSellerListRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsGetSellerListResponse, any>({
      path: `/cv-assistant/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name DetailsCreate
   * @request POST:/cv-assistant/details
   */
  detailsCreate = (data: CvassistantCvAssistantProtocolsGetSellerDetailsRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsGetSellerDetailsResponse, any>({
      path: `/cv-assistant/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ListingDetailsCreate
   * @request POST:/cv-assistant/listing/details
   */
  listingDetailsCreate = (
    data: CvassistantCvAssistantProtocolsGetDetectedListingDetailsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<CvassistantCvAssistantProtocolsGetDetectedListingDetailsResponse, any>({
      path: `/cv-assistant/listing/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name EngageCreate
   * @request POST:/cv-assistant/engage
   */
  engageCreate = (data: CvassistantCvAssistantProtocolsEngageSellersRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsEngageSellersResponse, any>({
      path: `/cv-assistant/engage`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name DismissCreate
   * @request POST:/cv-assistant/dismiss
   */
  dismissCreate = (data: CvassistantCvAssistantProtocolsDismissSellersRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsDismissSellersResponse, any>({
      path: `/cv-assistant/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name AuthorizeCreate
   * @request POST:/cv-assistant/authorize
   */
  authorizeCreate = (data: CvassistantCvAssistantProtocolsAuthorizeSellersRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsAuthorizeSellersResponse, any>({
      path: `/cv-assistant/authorize`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ExcelExportSellerIdCreate
   * @request POST:/cv-assistant/excel/export/seller-id
   */
  excelExportSellerIdCreate = (
    data: CvassistantCvAssistantProtocolsExcelExportBySellerIdRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/cv-assistant/excel/export/seller-id`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ExcelExportCreate
   * @request POST:/cv-assistant/excel/export
   */
  excelExportCreate = (data: CvassistantCvAssistantProtocolsExcelExportRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsExcelExportResponse, any>({
      path: `/cv-assistant/excel/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ChatSnapshotCreate
   * @request POST:/cv-assistant/chat/snapshot
   */
  chatSnapshotCreate = (data: CvassistantCvAssistantProtocolsGetChatAsSnapshotRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsFileInfoListResponse, any>({
      path: `/cv-assistant/chat/snapshot`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name ChatExcelCreate
   * @request POST:/cv-assistant/chat/excel
   */
  chatExcelCreate = (data: CvassistantCvAssistantProtocolsGetChatAsExcelRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/cv-assistant/chat/excel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ConversationalAssistant
   * @name FilterResultCreate
   * @request POST:/cv-assistant/filter/result
   */
  filterResultCreate = (data: CvassistantCvAssistantProtocolsGetFilterInfoResultRequest, params: RequestParams = {}) =>
    this.http.request<CvassistantCvAssistantProtocolsGetFilterInfoResultResponse, any>({
      path: `/cv-assistant/filter/result`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
